import React from 'react';
import { Link } from 'react-router-dom';


export default function LeftSidebar(param) {
    const [activeClassName, setActiveClassName] = React.useState('nav-link active');
    const [inactiveClassName, setInactiveClassName] = React.useState('nav-link');
    const [menu, setMenu] = React.useState('SCHEDULE'); // 선택한 메뉴. 디폴트는 스케줄

    const scheduleUrl = '/schedule';
    const contentsUrl = '/contents';
    const projectUrl = '/project';
    const tagUrl = '/tag';
    const organizationUrl = '/organization';
    const deliveryUrl = '/delivery';
    const forwardUrl = '/forward';


    const scheduleIconClassName = 'nav-icon far fa-calendar-alt';
    const contentsIconClassName = 'nav-icon fas fa-photo-video';
    const projectIconClassName = 'nav-icon fas fa-project-diagram';
    const tagIconClassName = 'nav-icon fas fa-tags';
    const organizationIconClassName = 'nav-icon fas fa-sitemap';
    const deliveryIconClassName = 'nav-icon fas fa-history';
    const forwardIconClassName = 'nav-icon fas fa-share-alt-square';
    const navItemClassName = 'nav-item';

    React.useEffect(() => {
        const curUrl = window.location.href;
        console.log(curUrl);
        if(curUrl.indexOf('schedule') > 0) setMenu('SCHEDULE');
        else if(curUrl.indexOf('contents') > 0) setMenu('CONTENTS');
        else if(curUrl.indexOf('project') > 0) setMenu('PROJECT');
        else if(curUrl.indexOf('tag') > 0) setMenu('TAG');
        else if(curUrl.indexOf('organization') > 0) setMenu('ORGANIZATION');
        else if(curUrl.indexOf('delivery') > 0) setMenu('DELIVERY');
        else if(curUrl.indexOf('forward') > 0) setMenu('FORWARD');
        else setMenu('SCHEDULE');
    });

    return(
        
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <div className="sidebar-header sidebarHeader text-center">
                <Link  to="/schedule" className="brand-link ">
                    <img src="/dist/img/myhealthCMS_logo.png" alt="AdminLTE Logo" className="brand-image-xl" /> CMS
                    {/* <h4 className="brand-text font-weight-bolder">CMS</h4> */}
                </Link>
            </div>

            <div className="sidebar">
            
                <nav className="mt-2">

                    <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                        <li className={navItemClassName} >
                           { menu === 'ORGANIZATION'  &&  <Link to={organizationUrl}  className={activeClassName} onClick={() => setMenu('ORGANIZATION')} ><i className={organizationIconClassName}/><p> ORGANIZATION</p></Link> }
                           { menu !== 'ORGANIZATION' &&  <Link to={organizationUrl}  className={inactiveClassName} onClick={() => setMenu('ORGANIZATION')} ><i className={organizationIconClassName}/> <p> ORGANIZATION</p> </Link> }
                        </li>

                        <li className={navItemClassName} >
                           { menu === 'PROJECT'  &&  <Link to={projectUrl}  className={activeClassName} onClick={() => setMenu('PROJECT')} ><i className={projectIconClassName}/><p> PROJECT</p> </Link>}
                           { menu !== 'PROJECT' &&  <Link to={projectUrl}  className={inactiveClassName} onClick={() => setMenu('PROJECT')} ><i className={projectIconClassName}/><p> PROJECT</p></Link> }
                        </li>

                        <li className={navItemClassName} >
                           { menu === 'TAG'  &&  <Link to={tagUrl}  className={activeClassName} onClick={() => setMenu('TAG')} ><i className={tagIconClassName}/><p> TAG</p></Link> }
                           { menu !== 'TAG' &&   <Link to={tagUrl}  className={inactiveClassName} onClick={() => setMenu('TAG')} ><i className={tagIconClassName}/> <p> TAG</p> </Link> }
                        </li>

                        <li className={navItemClassName} >
                           { menu === 'CONTENTS'  &&  <Link to={contentsUrl}  className={activeClassName} onClick={() => setMenu('CONTENTS')} ><i className={contentsIconClassName}/><p> CONTENTS</p></Link> }
                           { menu !== 'CONTENTS' &&  <Link to={contentsUrl}  className={inactiveClassName} onClick={() => setMenu('CONTENTS')} ><i className={contentsIconClassName}/><p> CONTENTS</p></Link> }
                        </li>

                        <li className={navItemClassName} >
                           { menu === 'SCHEDULE' &&  <Link to={scheduleUrl}  className={activeClassName} onClick={() => setMenu('SCHEDULE')}  ><i className={scheduleIconClassName}/><p> SCHEDULE</p> </Link> }
                           { menu !== 'SCHEDULE' &&  <Link to={scheduleUrl}  className={inactiveClassName} onClick={() => setMenu('SCHEDULE')} ><i className={scheduleIconClassName}/><p> SCHEDULE</p></Link>}
                        </li>

                        <li className={navItemClassName} >
                           { menu === 'DELIVERY'  &&  <Link to={deliveryUrl}  className={activeClassName} onClick={() => setMenu('DELIVERY')} ><i className={deliveryIconClassName}/><p> DELIVERY</p></Link> }
                           { menu !== 'DELIVERY' &&  <Link to={deliveryUrl}  className={inactiveClassName} onClick={() => setMenu('DELIVERY')} ><i className={deliveryIconClassName}/> <p> DELIVERY</p> </Link> }
                        </li>

                        <li className={navItemClassName} >
                           { menu === 'FORWARD'  &&  <Link to={forwardUrl}  className={activeClassName} onClick={() => setMenu('FORWARD')} ><i className={forwardIconClassName}/><p> FORWARD</p></Link> }
                           { menu !== 'FORWARD' &&  <Link to={forwardUrl}  className={inactiveClassName} onClick={() => setMenu('FORWARD')} ><i className={forwardIconClassName}/> <p> FORWARD</p> </Link> }
                        </li>
                    </ul>

                </nav>
            </div>

        </aside>

    );
}